import produce from "immer";
import { CompanyInformationActions } from ".";
import {
  CLEAR_ACCOUNTING_COMPANY_INFORMATION,
  FETCH_ACCOUNTING_COMPANY_INFORMATION_FAILURE,
  FETCH_ACCOUNTING_COMPANY_INFORMATION_PROGRESS,
  FETCH_ACCOUNTING_COMPANY_INFORMATION_SUCCESS,
} from "./companyInformationActions";import { IStoreState } from "../initialStoreState";
import { initialCompanyInformation } from "./companyInformation.types";
import { LoadState } from "../../constants/enums";
;

export const companyInformationReducer = (
  state: IStoreState["companyInformation"] = initialCompanyInformation,
  action: CompanyInformationActions
) => {
  switch (action.type) {
    case FETCH_ACCOUNTING_COMPANY_INFORMATION_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.data = initialCompanyInformation["data"];
        draftState.error = "";
      });
      return newState;
    }
    case FETCH_ACCOUNTING_COMPANY_INFORMATION_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.data = data;
      });
      return newState;
    }
    case FETCH_ACCOUNTING_COMPANY_INFORMATION_FAILURE: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.data = initialCompanyInformation["data"];
        draftState.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_ACCOUNTING_COMPANY_INFORMATION: {
      return initialCompanyInformation;
    }
    default:
      return state;
  }
};
